import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import type { FindReleasedInvoices, PaginatedInvoice } from "contracts/Invoice";
import type { Pagination } from "contracts/Pagination";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess", "onFailure"],
    success: ["data", "pagination"],
    failure: ["errorMessage"],
    softReset: [],
    reset: [],
  },
  {
    prefix: "PAGINATE_RELEASED_INVOICES_",
  }
);

export interface PaginateReleasedInvoicesState {
  data: PaginatedInvoice[];
  pagination?: Pagination;
  loading: boolean;
  errorMessage: string | null;
}

export interface PaginateReleasedInvoicesRequestAction {
  query?: FindReleasedInvoices;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: PaginatedInvoice[];
  pagination: Pagination;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: PaginateReleasedInvoicesState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: PaginateReleasedInvoicesState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: PaginateReleasedInvoicesState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
    pagination: { $set: action.pagination },
  });

const failure = (state: PaginateReleasedInvoicesState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: PaginateReleasedInvoicesState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = (state: PaginateReleasedInvoicesState) =>
  update(state, {
    data: { $set: {} },
  });

export const paginateReleasedInvoices = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const PaginateReleasedInvoicesTypes = Types;
export const PaginateReleasedInvoicesActions = Creators;
